module.exports = __webpack_public_path__ + "img/about_logo_03.fc833f35.png";